import VueRouter from 'vue-router'
import { Store } from 'vuex'

export default {
  handler(router: VueRouter, store: Store<any>, error: any) {
    const accountID = store.get('app/accountID')
    const billingUrl = `${
      process.env.VUE_APP_SERVER_SIDE_APP_URL
    }/app/${accountID}/account/billing-information`
    window.location.href = billingUrl
  },
}
